module.exports = "<div class=\"loader-container\">\r\n\t<h2>Preparando histórico...</h2>\r\n\t<div class=\"sk-double-bounce\">\r\n\t\t<div class=\"double-bounce1\"></div>\r\n\t\t<div class=\"double-bounce2\"></div>\r\n\t</div>\r\n</div>\r\n<div class=\"history-table hidden\">\r\n\t\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/history-section/history-section.tpl.html
// module id = 130
// module chunks = 0